var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('p',{staticClass:"empty-state-text",style:({ height: _vm.height + 'px', h: _vm.h + '%' })},[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }